import { Type } from 'class-transformer';
import { Length, ValidateNested } from 'class-validator';

import { SliderButtonPathConfigModel } from './sliderButtonPathConfig.model';

export class SliderButtonSettingsModel {
  @Length(3, 1000)
  public label: string;

  @ValidateNested()
  @Type(() => SliderButtonPathConfigModel)
  public path: SliderButtonPathConfigModel;
}
